import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'mojo-not-licensed',
    templateUrl: './not-licensed.component.html',
    standalone: false
})
export class NotLicensedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
